export default import.meta.ROLLDOWN_FILE_URL_nP8vXbN00dgA0dcDrP5Aiw